import styled from "styled-components";

export const TitleQuery = styled.span`
  margin-left: ${({ theme }) => theme.spacing.xs};
  font-size: 24px;
  color: ${({ theme }) => theme.color.solid.grey};
`;
